const AmbitoOptions = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Local',
    value: 'Local',
  },
  {
    label: 'Federal',
    value: 'Federal',
  }
];

export default AmbitoOptions;